export var ALMA_JS_URL = 'https://cdn.jsdelivr.net/npm/@alma/widgets@3.x/dist/widgets.umd.js';
export var ALMA_CSS_URL = 'https://cdn.jsdelivr.net/npm/@alma/widgets@3.x/dist/widgets.min.css';
export var ALMA_KEY_LIVE = '11uG3uq3FfwKb2vLMdeEs69jvm1V77TcMc';
export var ALMA_KEY_TEST = '11ued2M23tqQiYnB8qmZfHKcl0pmj5tvcz';
export var ALMA_MIN_AMOUNT = 90;
export var ALMA_PAYMENT_PLANS = [{
  installmentsCount: 3,
  minAmount: 9000,
  maxAmount: 800000
}, {
  installmentsCount: 4,
  minAmount: 9000,
  maxAmount: 800000
}, {
  installmentsCount: 10,
  minAmount: 25000,
  maxAmount: 500000
}, {
  installmentsCount: 12,
  minAmount: 25000,
  maxAmount: 500000
}, {
  installmentsCount: 24,
  minAmount: 25000,
  maxAmount: 500000
}];
export var ALMA_PAYMENT_PLANS_WITHOUT_ALMA3 = [{
  installmentsCount: 4,
  minAmount: 9000,
  maxAmount: 800000
}, {
  installmentsCount: 10,
  minAmount: 25000,
  maxAmount: 500000
}, {
  installmentsCount: 12,
  minAmount: 25000,
  maxAmount: 500000
}, {
  installmentsCount: 24,
  minAmount: 25000,
  maxAmount: 500000
}];
export var ALMA_PAYMENT_PLANS_WITHOUT_ALMA4 = [{
  installmentsCount: 3,
  minAmount: 9000,
  maxAmount: 800000
}, {
  installmentsCount: 10,
  minAmount: 25000,
  maxAmount: 500000
}, {
  installmentsCount: 12,
  minAmount: 25000,
  maxAmount: 500000
}, {
  installmentsCount: 24,
  minAmount: 25000,
  maxAmount: 500000
}];